import { createContext } from 'react'
import type { RtpcQuery } from '../../dtos/rtpc/RtpcQuery'

export const rtpcFilterContext = createContext<RtpcQuery>({} as RtpcQuery)
